import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPlanningCommentsQuickInfo extends Layout {
    labelDriver2: Label;
    labelDriver: Label;
    labelOrder: Label;
    labelTractor: Label;
    labelTrailer2: Label;
    labelTrailer3: Label;
    labelTrailer: Label;
    panelComments: Panel;
    sourceEquipMove: DataSource;
    textboxDriver2Comment: Textbox;
    textboxDriverComment: Textbox;
    textboxPlanningComment: Textbox;
    textboxTractorComment: Textbox;
    textboxTrailer2Comment: Textbox;
    textboxTrailer3Comment: Textbox;
    textboxTrailerComment: Textbox;
}
